import { InteractionConfig } from './types';

export default function Interaction(props: {
	shouldPlay: boolean;
	config: InteractionConfig;
	onLoaded: () => void;
	onDone: () => void;
	onError: (e: Error) => void;
}) {
	// call after preloading is done
	props.onLoaded();
	// call onDone when your interaction is done or after some timeout
	setTimeout(() => {
		props.onDone();
	}, props.config.timeout);

	if (props.shouldPlay) {
		// play videos, sounds, etc
		let achievementSoundRare = new Audio('/XboxOneRareAchievement.mp3')
		achievementSoundRare.volume = 0.5
		const achievement = () => {
				document.querySelector('.achievement').classList.add('rare')
				achievementSoundRare.play()
				document.querySelector('.circle').classList.add('circle_animate')
				document.querySelector('.banner').classList.add('banner-animate')
				document.querySelector('.achieve_disp').classList.add('achieve_disp_animate')
				setTimeout(() => {
					document.querySelector('.circle').classList.remove('circle_animate')
					document.querySelector('.banner').classList.remove('banner-animate')
					document.querySelector('.achieve_disp').classList.remove('achieve_disp_animate')
					document.querySelector('.achievement').classList.remove('rare')
			}, 12000)
		}
		achievement()
	}

	return (
		<div className="content">
        <div className="achievement" style={{
			transform: "scale(1.6)",
			transformOrigin: "center center"
		}}>
            <div className="animation">
                <div className="circle">
                    <div className="img xbox_img">
											<img src="/Logo.svg" style={{
												fill: "white"
											}} alt="logo"/>
                    </div>
                    <div className="brilliant-wrap">
                        <div className="brilliant">
                        </div>
                    </div>
                </div>
                <div className="banner-outer">
                    <div className="banner">
                        <div className="achieve_disp">
                            <span className="unlocked">
															{props.config.msgFrom} Unlocked:
                            </span>
                            <div className="score_disp">
                                <div className="gamerscore">
                                    <img width="20px" src="/G.svg" alt="G"/>
                                    <span className="acheive_score">100</span>
                                </div>
                                <span className="hyphen_sep">-</span>
                                <span className="achiev_name">{props.config.message}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
	);
}
